module.exports = __webpack_public_path__ + "img/头图.7ed82f84.png";